// True during the build-time prerender, and in the browser when the page arrived
// with prerendered markup (evaluated before React renders into #root).
export const isPrerendered =
  typeof document === "undefined" ||
  !!document.getElementById("root")?.firstElementChild;
